
import StoryblokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'

export default {
  components: {
    StoryblokComponent,
  },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    containerStyles() {
      const styles = {}

      // grid options
      if (this.blok.display === 'grid' || this.blok.display === 'inline-grid') {
        if (this.blok?.autoColumns) {
          styles.gridTemplateColumns = `repeat(${this.getBreakpointValue(
            this.blok?.autoColumns
          )}, minmax(0, 1fr))`
        } else if (this.blok.templateColumns) {
          styles.gridTemplateColumns = this.buildGridTemplateColumns(
            this.getBreakpointValue(this.blok?.templateColumns)
          )
        }

        styles.columnGap = this.getBreakpointValue(this.blok?.columnGap)
        styles.rowGap = this.getBreakpointValue(this.blok?.rowGap)
        styles.justifyItems = this.getBreakpointValue(this.blok.justifyItems)
      }

      // flex options
      if (this.blok.display === 'flex' || this.blok.display === 'inline-flex') {
        styles.flexDirection = this.getBreakpointValue(this.blok.flexDirection)
        styles.justifyContent = this.getBreakpointValue(
          this.blok.justifyContent
        )
      }
      styles.alignItems = this.getBreakpointValue(this.blok.alignItems)
      styles.padding = this.getBreakpointValue(this.blok.padding)
      styles.margin = this.getBreakpointValue(this.blok.margin)

      return styles
    },
  },
  methods: {
    buildGridTemplateColumns(sizes) {
      if (!sizes) return null

      const columnSizes = sizes
        .replace(/\s/g, '')
        .split(',')
        ?.reduce((acc, next) => {
          return acc + ` ${next}fr`
        }, '')
      return columnSizes
    },
  },
}
